@if ({
  hasPatron: patronSelectors.hasPatron | select: false,
  available: availabilitySelectors.availableAtPatronsBranchFor(availability) | select:false,
  availableAtOtherBranches: availabilitySelectors.availableAtOtherBranchesFor(availability) | select:0
}; as vm) {
  <div class="flex flex-col gap-3" [ngClass]="{'items-center': forTableColumn}">
    <div class="flex flex-col" [ngClass]="{'items-center': forTableColumn}">
      <div class="flex flex-row" [ngClass]="forTableColumn ? 'items-start' : 'items-center'">
        <div class="flex shrink-0">
          @if ((vm.hasPatron && vm.available) || (!vm.hasPatron && vm.availableAtOtherBranches > 0)) {
            <mat-icon class="text-success mr-2" [ngClass]="forTableColumn ? 'mat-icon-size-5' : 'mat-icon-size-10'">check_circle</mat-icon>
          } @else {
            <mat-icon class="text-error mr-2" [ngClass]="forTableColumn ? 'mat-icon-size-5' : 'mat-icon-size-10'">cancel</mat-icon>
          }
        </div>
        <div class="flex flex-col">
          @if (vm.hasPatron) {
            <div class="flex text-title-medium" [ngClass]="forTableColumn ? 'flex-col' : 'flex-row'">
              <p>{{ vm.available ? 'Available at' : 'Unavailable at' }}</p>
              @if (!forTableColumn) {
                <p>&nbsp;{{ authBranchSelectors.name | select }}</p>
              }
            </div>
          }
          @if (!forTableColumn) {
            <ng-container *ngTemplateOutlet="otherLocationInfo"/>
          }
        </div>
      </div>
      @if (forTableColumn) {
        <p class="text-title-medium">{{ authBranchSelectors.name | select }}</p>
      }
    </div>

    @if (forTableColumn) {
      <ng-container *ngTemplateOutlet="otherLocationInfo"/>
    }
  </div>

  <ng-template #otherLocationInfo>
    <div>
      <span class="text-title-medium" [class.text-success]="vm.availableAtOtherBranches > 0">{{ vm.availableAtOtherBranches }} Available</span>
      @if (vm.hasPatron) {
        <span class="text-body-large"> at other locations</span>
      }
    </div>
  </ng-template>
}
